@if (
  {
    isFormValid: isFormValid$ | async,
    isGettingResetOtp: isGettingResetOtp$ | async,
    violations: violations$ | async
  };
  as STATE
) {
  <form
    class="form reset-password-form"
    [formGroup]="forgotPasswordForm"
    (ngSubmit)="onSubmit()"
    [ngxsForm]="statePropertyPath"
  >
    <div class="form__group">
      <label for="email" class="form__label"
        >Adresse électronique
        <span class="form__label--required">*</span>
      </label>
      <div class="form__item form__item--with-prefix">
        <span class="form__prefix">
          <mat-icon svgIcon="dgi-msg" color="primary"></mat-icon>
        </span>
        <input
          matInput
          formControlName="email"
          id="email"
          required
          type="email"
          class="form__input"
          placeholder="Saisir l'adresse électronique"
        />
      </div>
      <mat-error
        *ngIf="email?.touched && email?.errors?.required"
        [innerHtml]="'Ce champ est requis'"
        class="form__error-red"
      >
      </mat-error>
      <mat-error
        *ngIf="email?.touched && email?.errors?.email"
        [innerHtml]="'Veuillez entrer une adresse e-mail valide'"
        class="form__error-red"
      >
      </mat-error>
      <mat-error *ngIf="email?.getError('httpError') as httpError">
        {{ httpError }}
      </mat-error>
    </div>

    <div class="form__actions">
      <button
        button
        type="submit"
        button
        [disabled]="forgotPasswordForm.invalid"
        [loading]="!!STATE.isGettingResetOtp"
        loadingText="Envoi en cours..."
        size="lg"
        [fullWidth]="true"
      >
        <span>Envoyer le code de vérification</span>
      </button>

      <p class="form__actions--text">
        Je me souviens de mon mot de passe ?
        <span>
          <a [routerLink]="routes.login" class="form__actions--link"
            >Se connecter</a
          >
        </span>
      </p>
    </div>
  </form>
}
